import GroupAddIcon from '@mui/icons-material/GroupAdd';
import Button from '@mui/material/Button';
import { PageHeader, PageHeaderToolbar } from '@toolpad/core';
import React from 'react';
import { useTranslation } from 'react-i18next';

type PageHeaderToolbarProps = {
    onAdd?: () => void;
};

export function ClassPageToolbar(props: PageHeaderToolbarProps) {
    const { t } = useTranslation();
    return (
        <PageHeaderToolbar>
            <Button variant='contained' startIcon={<GroupAddIcon />} onClick={props.onAdd}>
                {t('common.create')}
            </Button>
        </PageHeaderToolbar>
    );
}

export function ClassPageHeader(props: PageHeaderToolbarProps) {
    const ClassPageToolbarComponent = React.useCallback(() => <ClassPageToolbar {...props} />, [props]);
    return <PageHeader slots={{ toolbar: ClassPageToolbarComponent }} breadcrumbs={[]} />;
}
